import { supabase } from "@/integrations/supabase/client";

async function call(action: string, payload: Record<string, unknown> = {}) {
  const { data, error } = await supabase.functions.invoke("mock-payments", {
    body: { action, ...payload },
  });
  if (error) throw error;
  if (data?.error) throw new Error(data.error);
  return data;
}

export const payments = {
  startSubscriptionCheckout: (planId: string) =>
    call("checkout_subscription", { plan_id: planId }),
  startBoostCheckout: (ideaId: string, packageId: string) =>
    call("checkout_boost", { idea_id: ideaId, package_id: packageId }),
  cancelSubscription: (subscriptionId: string) =>
    call("cancel_subscription", { subscription_id: subscriptionId }),
};

export const PROVIDER = "mock" as const;